<template>
    <div class="customerListBox">
        <!-- Query area -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t(I18N_KEY + 'mobile')">
                  <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'mobile'))" v-model="queryParam.mobileNo"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item label="Batch No.">
                  <a-input :placeholder="$t('enter') + 'Batch No.'" v-model="queryParam.appssid"></a-input>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="loadData(1)" icon="search">{{ $t('search') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
                  <a-button type="primary" @click="exeClearGoogle" icon="reload" style="margin-left: 8px">Reset Google Account</a-button>
                </span>
              </a-col>

            </a-row>
          </a-form>
        </div>
        <a-table
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            bordered
            ref="table"
            size="middle"
            rowKey="id">
            <span slot="action" slot-scope="text, record">
<!--                <a @click="handleJsonView(record)">{{ $t('view') }}</a>-->
<!--                <br/>-->
                <a @click="handleJsonView(record)" >Large JSON</a>
                <!-- <a @click="handleDetail2(record)">{{ 'xxx' }}</a> -->
              <a-divider type="vertical"/>
              <a @click="handleToolJsonView(record)" >Tooljson</a>
               <a-divider type="vertical"/>
              <a @click="handlePointJsonView(record)" >Trackingjson</a>
              <a-divider type="vertical"/>
              <a @click="handleVideoView(record)" >Video(Malay)</a>
              <a-divider type="vertical"/>
              <a @click="handleSignatureView(record)" >Signature(Malay)</a>
              <a-divider type="vertical"/>
              <a @click="fireBasePush(record)" >fireBasePush</a>
            </span>
        </a-table>
        <div style="margin-top: 15px; text-align: right;">
            <v-pagination
                v-if="total"
                :page-num="form.pageNum"
                :page-size="form.pageSize"
                :total="total"
                @change="handleTableChange" />
        </div>
        <v-modal
            v-model="visible"
            :title="$t(I18N_KEY + 'customerDetail')">
            <div style="padding: 20px;">
                <customer-detail v-if="visible" :id="customerId" ref="customerDetail"/>
            </div>
        </v-modal>
         <TestJSONListModal ref="testJSONListModal" @ok="modalFormOk"></TestJSONListModal>
         <TestToolJSONListModal ref="testToolJSONListModal" @ok="modalFormOk"></TestToolJSONListModal>
         <TestPointJSONListModal ref="testPointJSONListModal" @ok="modalFormOk"></TestPointJSONListModal>
         <TestVideoListModal ref="testVideoListModal" @ok="modalFormOk"></TestVideoListModal>
         <TestSignatureListModal ref="testSignatureListModal" @ok="modalFormOk"></TestSignatureListModal>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment'
    import vModal from '../modules/Modal';
    import CustomerModal from './modules/CustomerModal'
    import TestJSONListModal from './modules/TestJSONListModal'
    import TestToolJSONListModal from './modules/TestToolJSONListModal'
    import TestPointJSONListModal from './modules/TestPointJSONListModal'
    import TestVideoListModal from './modules/TestVideoListModal'
    import TestSignatureListModal from './modules/TestSignatureListModal'
    import { clearGoogleAccount, fireBasePush } from '@/webpublicapi/customer'
    import CustomerDetail from './CustomerDetail';
    import Dict from '../modules/Dict';
    import DictSelect from '../modules/DictSelect';
    import TestOrderModal from '@/views/webpublic/platformOrder/modules/TestOrderModal.vue'

    const I18N_KEY = 'customer.';
    export default {
        components: {
          TestOrderModal,
            Dict,
            DictSelect,
            vModal,
            CustomerDetail,
            CustomerModal,
          TestJSONListModal,
          TestToolJSONListModal,
          TestVideoListModal,
          TestPointJSONListModal,
          TestSignatureListModal
        },
        data () {
            return {
                moment,
                I18N_KEY,
                loading: false,
                customerId: undefined,
                form: {
                    pageNum: 1,
                    pageSize: 30,
                },
                defaultQueryParam: {
                    aadhaarNo: undefined,
                    mobileNo: undefined,
                    panNo: undefined,
                    createdTime: undefined,
                    beginDate: undefined,
                    endDate: undefined,
                },
                queryParam: {
                  mobileNo: '',
                  appssid: ''
                },
                visible: false,
                toggleSearchStatus: false,
            }
        },
        computed: {
            ...mapGetters('customer', [
                'testCustomerList',
            ]),
            // Table header
            columns () {
                return [
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        key:'id',
                        width:60,
                        align:"center"
                    },
                    {
                        title: this.$t(I18N_KEY + 'mobile'),
                        align:"center",
                        dataIndex: 'mobileNo'
                    },
                    {
                        title: this.$t(I18N_KEY + 'names'),
                        align:"center",
                        dataIndex: 'names'
                    },
                    {
                        title: this.$t(I18N_KEY + 'surnames'),
                        align:"center",
                        dataIndex: 'surnames'
                    },
                  {
                    title: 'appssid',
                    align:"center",
                    dataIndex: 'appssid'
                  },

                    {
                      title: this.$t(I18N_KEY + 'curp'),
                      align:"center",
                      dataIndex: 'curp'
                    },
                    {
                      title: this.$t(I18N_KEY + 'createTime'),
                      align:"center",
                      dataIndex: 'createdTime'
                    },
                    {
                        title: this.$t('action'),
                        dataIndex: 'action',
                        align:"center",
                        scopedSlots: { customRender: 'action' },
                    }]
            },
            dataSource(){
              return (this.testCustomerList && this.testCustomerList.rows) || [];
            },
            total () {
                return this.testCustomerList && this.testCustomerList.total || 0;
            },
            pagination () {
                return {
                    pageSize: this.form.pageSize,
                    current: this.form.pageNum,
                    total: this.total,
                    showTotal: function(total) {
                      return "Total " + total + " records";
                    }
                }
            },
            element () {
                return document.querySelector('.aaa');
            }
        },
        watch: {
            roleList (data) {
                const list = (data && data.rows) || []
                list.length && (this.dataSource = list);
            }
        },
        created () {
            window.xx = this;
            this.getDict();
            this.basicForm = { ...this.defaultBasicForm };
            this.queryParam = { ...this.defaultQueryParam };
            // this.loadData();
        },
        methods: {
            ...mapActions('customer', [
                'getTestCustomerList'
            ]),
            modalContainer () {
                return document.querySelector('.customerListBox')
            },
            handleTableChange (pageNum, pageSize) {
                this.form.pageNum = pageNum;
                this.form.pageSize = pageSize;
                this.loadData();
            },
            handleToggleSearch(){
                this.toggleSearchStatus = !this.toggleSearchStatus;
            },
            handleJsonView (record) {
                this.$refs.testJSONListModal.edit(record)
                this.$refs.testJSONListModal.title = 'Display'
            },
            handleToolJsonView(record){
                this.$refs.testToolJSONListModal.edit(record)
                this.$refs.testToolJSONListModal.title = 'Display'
            },

          handlePointJsonView(record){
            this.$refs.testPointJSONListModal.edit(record)
            this.$refs.testPointJSONListModal.title = 'Display'
          },
            handleVideoView(record) {
                this.$refs.testVideoListModal.edit(record)
                this.$refs.testVideoListModal.title = 'Display'
            },
            handleSignatureView(record) {
                this.$refs.testSignatureListModal.edit(record)
                this.$refs.testSignatureListModal.title = 'Display'
            },
            fireBasePush(record) {
              this.loading = true;
              fireBasePush({customerId: record.id}).then(res => {
                this.loading = false;
              }).catch(e => {
                this.loading = false;
                this.$message.error(e.message);
              });
            },
            transformMenuListToTree (list) {
                return list.map(item => {
                    return {
                        ...item,
                        value: '' + item.id,
                        title: item.nameEn || '',
                        key: '' + item.id,
                        children: this.transformMenuListToTree(item.children || [])
                    }
                })
            },
            transformStringToLow (str) {
                return str && str.toLocaleLowerCase();
            },
            changeModal (visible) {
                this.visible = visible;
            },
            requestMenuListAndRolePermission (id) {
                return Promise.all([
                    this.getMenuListTree(),
                    this.getRolePermission({ roleId: id }),
                ])
            },
            searchReset () {
                this.form = {
                    keywords: undefined,
                    pageNum: 1,
                    pageSize: 30,
                }
                this.queryParam = { ...this.defaultQueryParam };
                this.loadData(1);
            },
            // modelCallback
            modalFormOk () {
              this.loadData()
            },

            handleDetail (row) {
                this.customerId = row.id;
                this.changeModal(true);
            },
            transformTime (time) {
                return moment(time).format('YYYY-MM-DD')
            },
            exeClearGoogle () {
                this.loading = true;
                const data = {
                  jobName: 'deleteTestDataHandler',
                  params: ''
                }
            clearGoogleAccount(data).then(res => {
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                this.$message.error(e.message);
            });

          },
          loadData (pageNum) {
              if(pageNum) { this.form.pageNum = pageNum; }
              const { createdTime } = this.queryParam;
              const data = {
                  ...this.form,
                  ...this.queryParam,
                  beginDate: createdTime && this.transformTime(createdTime[0]),
                  endDate: createdTime && this.transformTime(createdTime[1]),
              }
              delete data.createdTime;
              this.loading = true;
              this.getTestCustomerList(data).then(res => {
                  this.loading = false;
              }).catch(e => {
                  this.loading = false;
                  this.$message.error(e.message);
              });
          }
        }
    }
</script>
<style scoped>
  @import '~@/assets/less/common.less';
</style>
